// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YCwF3n7aaNoOVsVf {
  padding: 24px;
}
.vS62wEfz8z4p6KAf {
  margin-bottom: 16px;
  color: #666;
  line-height: 22px;
}
.Hjx7_ehJggYGoEJq {
  cursor: pointer;
  border: 1px solid #e8e8e8 !important;
  border-radius: 8px;
  padding: 14px 16px !important;
  margin-bottom: 12px;
  transition: all 0.2s ease;
  position: relative;
}
.Hjx7_ehJggYGoEJq:hover {
  border-color: #91caff !important;
  background: #f0f7ff;
}
.ZKNdLceVJ2wMdiUo {
  background: #f6ffed;
  border-color: #b7eb8f !important;
}
.ZKNdLceVJ2wMdiUo:hover {
  background: #f6ffed;
  border-color: #95de64 !important;
}
.Yhw5GkeWtwU4NNQa {
  border-color: #1677ff !important;
  background: #e6f4ff;
  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
}
.Yhw5GkeWtwU4NNQa::after {
  content: "✓";
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  border-radius: 50%;
  background: #1677ff;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
}
.Yhw5GkeWtwU4NNQa:hover {
  background: #e6f4ff;
  border-color: #1677ff;
}
.vhxznWhZaRwnGLql {
  width: 100%;
}
.DzMiFtYdbEAOV3TS {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
}
.G4D_Q0x2S4ccSVcV {
  margin-top: 6px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.HR8O_57OSHYDn2jQ {
  color: #888;
  font-size: 13px;
}
.eSoMbSR5CY49wnRc {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./app/assets/pages/identitySelect/index.modules.less"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AAEA;EACE,mBAAA;EACA,WAAA;EACA,iBAAA;AAAF;AAGA;EACE,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AADF;AAGE;EACE,gCAAA;EACA,mBAAA;AADJ;AAKA;EACE,mBAAA;EACA,gCAAA;AAHF;AAKE;EACE,mBAAA;EACA,gCAAA;AAHJ;AAOA;EACE,gCAAA;EACA,mBAAA;EACA,6CAAA;AALF;AAOE;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AALJ;AAQE;EACE,mBAAA;EACA,qBAAA;AANJ;AAUA;EACE,WAAA;AARF;AAWA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AATF;AAYA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AAVF;AAaA;EACE,WAAA;EACA,eAAA;AAXF;AAcA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;AAZF","sourcesContent":[".page {\n  padding: 24px;\n}\n\n.description {\n  margin-bottom: 16px;\n  color: #666;\n  line-height: 22px;\n}\n\n.identityItem {\n  cursor: pointer;\n  border: 1px solid #e8e8e8 !important;\n  border-radius: 8px;\n  padding: 14px 16px !important;\n  margin-bottom: 12px;\n  transition: all 0.2s ease;\n  position: relative;\n\n  &:hover {\n    border-color: #91caff !important;\n    background: #f0f7ff;\n  }\n}\n\n.identityItemCurrent {\n  background: #f6ffed;\n  border-color: #b7eb8f !important;\n\n  &:hover {\n    background: #f6ffed;\n    border-color: #95de64 !important;\n  }\n}\n\n.identityItemActive {\n  border-color: #1677ff !important;\n  background: #e6f4ff;\n  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);\n\n  &::after {\n    content: \"✓\";\n    position: absolute;\n    top: 50%;\n    right: 16px;\n    transform: translateY(-50%);\n    width: 22px;\n    height: 22px;\n    line-height: 22px;\n    text-align: center;\n    border-radius: 50%;\n    background: #1677ff;\n    color: #fff;\n    font-size: 12px;\n    font-weight: bold;\n  }\n\n  &:hover {\n    background: #e6f4ff;\n    border-color: #1677ff;\n  }\n}\n\n.identityContent {\n  width: 100%;\n}\n\n.vendorName {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.meta {\n  margin-top: 6px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.accountDisplay {\n  color: #888;\n  font-size: 13px;\n}\n\n.footer {\n  margin-top: 16px;\n  display: flex;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `YCwF3n7aaNoOVsVf`,
	"description": `vS62wEfz8z4p6KAf`,
	"identityItem": `Hjx7_ehJggYGoEJq`,
	"identityItemCurrent": `ZKNdLceVJ2wMdiUo`,
	"identityItemActive": `Yhw5GkeWtwU4NNQa`,
	"identityContent": `vhxznWhZaRwnGLql`,
	"vendorName": `DzMiFtYdbEAOV3TS`,
	"meta": `G4D_Q0x2S4ccSVcV`,
	"accountDisplay": `HR8O_57OSHYDn2jQ`,
	"footer": `eSoMbSR5CY49wnRc`
};
export default ___CSS_LOADER_EXPORT___;
